<template>
  <div class="contact-page-container">
    <p class="intro">
      <b>Vous souhaitez m’embaucher pour un projet ?</b><br />Envoyez-moi un message et je vous répondrai dès que
      possible.
    </p>
    <div>
      <ContactForm />
    </div>
    <div class="info">
      <div class="content-info">
        <div class="cv">
          <i class="icons8-download download-icon"></i>
            <a :href="pdfLink" download="etatibouet_cv.pdf">Télécharger mon CV</a>
        </div>
      </div>
      <p class="note">*Merci de ne pas l'envoyer à /dev/null</p>
      <div class="content-info">
        <i class="icons8-phone"></i>
        <a href="tel:+33632240958">06 32 24 09 58</a>
      </div>
      <div class="content-info">
        <i class="icons8-location"></i>
        <span>Nantes</span>
      </div>
    </div>
  </div>
</template>

<script>
import ContactForm from '@/components/ContactForm';

export default {
  name: 'ContactPage',
  components: {
    ContactForm
  },
  data() {
    return {
      pdfLink: '/etatibouet_cv.pdf'
    };
  }
};
</script>

<style lang="scss" scoped>
.contact-page-container {
  padding: 10px 20px 110px;
  background-color: var(--orange);
  height: 100vh;

  .intro {
    font-size: 14px;
  }

  .info {
    background-color: var(--orange);
    margin-top: 10px;
    padding: 25px 0;
    max-width: 100vw;

    .note {
      font-style: italic;
      padding: 0 20px;
      margin-top: 0;
      font-size: 14px !important;
    }

    padding: 50px 0;
    max-width: 100vw;

    .content-info {
      display: flex;
      flex-flow: row wrap;
      padding: 0 20px;
      justify-content: center;

      i {
        margin-right: 10px;
      }

      a {
        text-decoration: none;
        color: var(--black);
      }
    }
  }
}

@media screen and (min-width: 768px) {
  .contact-page-container {
    .intro {
      margin: 0 auto 20px;
      font-size: 20px;
    }
    .info {
      font-size: 20px;
    }
  }
}

@media screen and (min-width: 1024px) {
  .contact-page-container {
    padding: 10px 20px 210px;

    .info {
      .cv {
        translate: all 0.5s ease-out;
        border: 1px solid transparent;
        padding: 5px;
      }
      .cv:hover {
        border: 1px solid var(--darkgrey);
        padding: 5px;
        border-radius: 3px;
        background-color: var(--darkgrey);
        color: var(--white);

        a {
          color: var(--white);
        }
      }
    }
  }
}
</style>
